import { z } from "zod";

import { accountSchema } from "./account";

const onboardingCategorySchema = z
  .object({
    id: z.string().catch(""), // no id
    category_id: z.string(),
    category_name: z.string(),
    accounts: z.array(accountSchema),
    autofollow: z.boolean(),
  })
  .transform((category) => {
    category.id = category.category_id;
    return category;
  });

type OnboardingCategory = z.infer<typeof onboardingCategorySchema>;

export { onboardingCategorySchema, type OnboardingCategory };
